function getMixin (selector) {
    return {
        data () {
            return {
                webp: false,
                can_load_img: true,
            }
        }
    }
}

export default getMixin

